import { apiRequest } from "../lib/apiClient";
import type { InventoryBatchCorrection, InventoryBatchCreate, InventoryBatchOut } from "./types";

/** `GET /inventory/{id}/batches` — any authenticated user. FEFO order (soonest expiry
 * first, nulls last) — the same order a sale/write-off draws from. */
export async function listBatches(accessToken: string, itemId: string): Promise<InventoryBatchOut[]> {
  return apiRequest<InventoryBatchOut[]>(`/inventory/${itemId}/batches`, { accessToken });
}

/** `POST /inventory/{id}/batches` — OWNER/BRANCH_MANAGER/ECOM_MGR. Manual batch receipt
 * outside a purchase order (a delivery that was never logged as a PO, or backfilling a
 * record after the fact) — increments current_stock the same as any other receipt. */
export async function createBatch(accessToken: string, itemId: string, body: InventoryBatchCreate): Promise<InventoryBatchOut> {
  return apiRequest<InventoryBatchOut>(`/inventory/${itemId}/batches`, { method: "POST", accessToken, body });
}

/** `PATCH /inventory/{id}/batches/{batch_id}` — corrects a batch's identifying fields
 * (typo'd lot code, wrong expiry keyed in) WITHOUT moving any stock. */
export async function correctBatch(
  accessToken: string,
  itemId: string,
  batchId: string,
  body: InventoryBatchCorrection,
): Promise<InventoryBatchOut> {
  return apiRequest<InventoryBatchOut>(`/inventory/${itemId}/batches/${batchId}`, { method: "PATCH", accessToken, body });
}
